import { c as _c } from "react/compiler-runtime";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Options for redirecting to a page.
 */

/**
 * Arguments for the redirect function.
 */

/**
 * Type for the redirect function to any app page.
 * @param RouteType The type of route to redirect to.
 */

/**
 * Generic hook to redirect to any app page with type safety and flexible options.
 * Supports query params, origin preservation, and navigation state.
 */
export function useRedirectToPage() {
  const $ = _c(3);
  const navigate = useNavigate();
  const location = useLocation();
  let t0;
  if ($[0] !== location || $[1] !== navigate) {
    t0 = t1 => {
      const {
        route,
        options: t2
      } = t1;
      const options = t2 === undefined ? {} : t2;
      const {
        queryParams: t3,
        shouldPreserveOrigin: t4,
        originParamName: t5
      } = options;
      const queryParams = t3 === undefined ? {} : t3;
      const shouldPreserveOrigin = t4 === undefined ? false : t4;
      const originParamName = t5 === undefined ? "origin" : t5;
      const params = new URLSearchParams(queryParams);
      if (shouldPreserveOrigin) {
        const routeWithOrigin = `${location.pathname}${location.search}`;
        params.append(originParamName, routeWithOrigin);
      }
      navigate({
        pathname: route,
        search: params.toString()
      });
    };
    $[0] = location;
    $[1] = navigate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}